import React, {useContext} from 'react'
import {AppContext} from "../context/app-context";
import BaseNav from "./BaseNav";
import {mergeNavigationArray} from './LandingNav';
import {getUserBasedNavOptions} from "./nav-options";
import {useFilteredNav} from "../hooks/routing/useFilteredNav";
import { determineRightNav } from './nav/DefaultNav';

interface UserBasedNavProps {
  isHomeNav?: boolean;
}

const UserBasedNav: React.FC<UserBasedNavProps> = ({
                                                     isHomeNav = false
                                                   }) => {
  const context = useContext(AppContext)
  const {user} = context

  // getUserBasedNavOptions/determineRightNav already fall back to the
  // anonymous (logged-out) nav options when user is null/undefined, so we
  // must not short-circuit to [] here or logged-out users get a blank nav.
  const leftNavWithoutAccount = getUserBasedNavOptions(user);
  const rightNav = determineRightNav(user);
  const filteredNav = useFilteredNav(user, mergeNavigationArray(leftNavWithoutAccount, rightNav));

  return <BaseNav
    leftNavOptions={[]}
    rightNavOptions={filteredNav}
    logoUrl={isHomeNav ? `/app-images/logo/secure-space_white-logo_WTG.svg` : "/app-images/logo/secure-space_white-blue_WTG.svg"}
    fontColorOverride={isHomeNav ? true : undefined}
  />
}

export default UserBasedNav
